// interval for announcementbar
if(document.querySelector('.announcement-bar__wrapper p')){
    var currentIndex = 0;
    var slides = document.querySelectorAll('announcement-bar p');
  
    function nextSlide() {
      slides[currentIndex].classList.remove('reveal-invisible');
      slides[currentIndex].style.transform = 'translateY(-5px)';
      slides[currentIndex].style.opacity = 0;
      slides[currentIndex].style.visibility = 'hidden';
      currentIndex = (currentIndex + 1) % slides.length;
      slides[currentIndex].classList.add('reveal-invisible');
      slides[currentIndex].style.transform = 'translateY(0px)';
      slides[currentIndex].style.opacity = 1;
      slides[currentIndex].style.visibility = 'visible';
    }
  
    setInterval(nextSlide, 2500);
}

// edit all links to rel noopener

// Get all anchor elements on the page
const allLinks = document.querySelectorAll('a');

// Iterate through each link
allLinks.forEach(link => {
  // Check if the link has a target attribute set to "_blank"
  if (link.getAttribute('target') === '_blank') {
    // Check if the link already has a rel attribute
    const existingRel = link.getAttribute('rel');
    
    // Add "noopener" only if it's not already present
    if (!existingRel || !existingRel.includes('noopener')) {
      // Add "noopener" to the rel attribute, or set it if it doesn't exist
      link.setAttribute('rel', (existingRel ? existingRel + ' noopener' : 'noopener'));
    }
  }
});

// Fix H1 tags in chat widgets and other third-party elements
// This ensures only one H1 exists per page (the main page title)
function fixNonSemanticH1Tags() {
  // Get the main content H1 (should be the page title)
  const mainH1Selectors = [
    '.product-info__title h1',
    '.page h1',
    '.blog-banner h1',
    '.we-header h1',
    'h1.product-info__title',
    'h1.h1'
  ];
  
  let mainH1 = null;
  for (const selector of mainH1Selectors) {
    mainH1 = document.querySelector(selector);
    if (mainH1) break;
  }
  
  // Find all H1 elements on the page
  const allH1Elements = document.querySelectorAll('h1');
  
  allH1Elements.forEach(h1 => {
    // Skip the main page title H1
    if (mainH1 && h1 === mainH1) {
      return;
    }
    
    // Check if this H1 is in a chat widget or similar third-party element
    // Common patterns: chat widgets, popups, iframes, floating buttons
    const isChatWidget = h1.closest('[class*="chat"]') || 
                         h1.closest('[id*="chat"]') ||
                         h1.closest('[class*="messenger"]') ||
                         h1.closest('[id*="messenger"]') ||
                         h1.textContent.toLowerCase().includes('chat');
    
    // Replace H1 with a div to maintain semantic structure
    if (isChatWidget || !mainH1) {
      const replacement = document.createElement('div');
      
      // Copy all attributes
      Array.from(h1.attributes).forEach(attr => {
        replacement.setAttribute(attr.name, attr.value);
      });
      
      // Copy content
      replacement.innerHTML = h1.innerHTML;
      
      // Add a class to identify this was converted
      replacement.classList.add('h1-converted');
      
      // Preserve the visual styling
      const computedStyle = window.getComputedStyle(h1);
      replacement.style.fontSize = computedStyle.fontSize;
      replacement.style.fontWeight = computedStyle.fontWeight;
      replacement.style.lineHeight = computedStyle.lineHeight;
      replacement.style.margin = computedStyle.margin;
      replacement.style.padding = computedStyle.padding;
      
      // Replace the element
      h1.parentNode.replaceChild(replacement, h1);
      
      console.log('Fixed non-semantic H1 tag:', replacement);
    }
  });
}

// Run the fix after DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fixNonSemanticH1Tags);
} else {
  fixNonSemanticH1Tags();
}

// Run again after a delay to catch dynamically loaded chat widgets
setTimeout(fixNonSemanticH1Tags, 2000);
setTimeout(fixNonSemanticH1Tags, 5000);

// Watch for dynamically added H1 elements
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          // Check if the added node is an H1 or contains H1s
          if (node.tagName === 'H1' || node.querySelector('h1')) {
            fixNonSemanticH1Tags();
          }
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}